import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const createLevelApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/level`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateLevelApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/level/${payload._id}`,
      { name: payload.name }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getLevelApi = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/level`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
